import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import { Formik, Form } from 'formik';

import { SettingsContext } from '../../contexts';
import { FormHelper, ValidationHelper } from '../../helpers'
import { Alert, FieldGroup, Separator } from "../../components/index.jsx"
import { FormFooter, SocialButtons } from "./index.jsx"

const Step1 = ({
  onStepCompleted,
  onCancel,
  invitedUser,
  values,
  showSocialBtns = true,
  isMerchantClient = false,
}) => {
    const { isRetailCircle } = useContext(SettingsContext);
    const [stage, setStage] = useState('input');
    const [error, setError] = useState();
    const [authenticationProvider, setAuthenticationProvider] = useState(
        values.authentication_provider
    )

    const showStoreField = false;

    const fields = [
        'gender', 'birth_date',
        'first_name', 'last_name',
        'phone', 'email',
        ...(!isMerchantClient && !isRetailCircle ? ['password', 'password2'] : []),
        ...(showStoreField ? ['store_link', 'store_name'] : []),
    ];

    if (stage === 'verification') {
        fields.push('phone_code')
    }

    const validationSchema = ValidationHelper.schema(fields)
    const initialValues = FormHelper.initialValues(fields, values)

    const handleSocialLogin = (providerData, setFieldValue) => {
        setFieldValue('first_name', providerData.first_name)
        setFieldValue('last_name', providerData.last_name)
        setFieldValue('email', providerData.email)

        setAuthenticationProvider(providerData)
    }

    const startVerification = async (values) => {
        if (isMerchantClient) {
          return;
        }

        try {
            await ValidationHelper.phone.initiate(values.phone)
            setStage('verification')
        } catch (error) {
            setError("We weren't able to send the verification text. Please try again or" +
                " retry with a different number.")
        }
    }

    const completeVerification = async (values, { setFieldError }) => {
        if (isMerchantClient) {
            return onStepCompleted({
                ...values,
                ...{authentication_provider: authenticationProvider
            }});
        }

        try {
            await ValidationHelper.registration.validateContactData(
                values,
                invitedUser
            )

            onStepCompleted({
                ...values,
                ...{authentication_provider: authenticationProvider
            }})
        } catch (error) {
            if (error.response.data.errors) {
                for (let field in error.response.data.errors) {
                    setFieldError(field, error.response.data.errors[field].join(" "))
                }

                return
            }

            setError(error.response.data.message)
            setStage('input')
        }
    };

    return (
        <>
            <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                onSubmit={completeVerification}
            >
                {({ isSubmitting, setFieldValue, ...rest }) => (
                  <>
                    {!authenticationProvider && !invitedUser && showSocialBtns && !isRetailCircle && (
                        <>
                            <SocialButtons onSuccess={(d) => handleSocialLogin(d, setFieldValue)} />
                            <Separator noMargin />
                        </>
                    )}
                    <Form>
                        { error && <Alert message="Error" description={error} />}

                        <FieldGroup
                            name="gender"
                            type="radio"
                            options={[
                                { id: 'men', name: 'MR' },
                                { id: 'women', name: 'MS' }
                            ]}
                            required
                        />

                        <FieldGroup
                            placeholder="First Name"
                            readOnly={invitedUser && invitedUser.first_name}
                            name="first_name"
                            required
                        />

                        <FieldGroup
                            placeholder="Last Name"
                            readOnly={invitedUser && invitedUser.last_name}
                            name="last_name"
                            required
                        />

                        <FieldGroup
                            placeholder="Date of birth (DD/MM/YYYY)"
                            name="birth_date"
                            type="masked"
                            mask="99/99/9999"
                            required
                        />

                        <FieldGroup
                            placeholder="Phone number"
                            type="phone"
                            name="phone"
                            disabled={stage === 'verification'}
                            showVerification={false}
                            onVerificationCancelled={() => setStage('input')}
                            required
                        />

                        <FieldGroup
                            placeholder="Email"
                            readOnly={invitedUser && invitedUser.email}
                            type="email"
                            name="email"
                            required
                        />

                        {!isMerchantClient && !isRetailCircle && (
                          <div className="password">
                              <FieldGroup
                                  placeholder="Password"
                                  type="password"
                                  name="password"
                                  required
                              />

                              <FieldGroup
                                  placeholder="Confirm password"
                                  type="password"
                                  name="password2"
                                  required
                              />
                          </div>
                        )}

                        {showStoreField && (
                          <>
                            <FieldGroup
                                placeholder="Shopify Store Name"
                                name="store_name"
                                required
                            />

                            <FieldGroup
                                placeholder="Shopify Store Domain"
                                name="store_link"
                                required
                            />
                            <div className="info" style={{ margin: "5px 0 0 15px" }}>
                              Example: https://shop1.myshopify.com
                            </div>
                          </>
                        )}

                        {/** Used for the honeypot technique to block bots */}
                        <input type="text" id="secret-code" name="secret-code" value="" />

                        <FormFooter
                            step={1}
                            isSubmitting={isSubmitting}
                            onCancel={onCancel}
                        />

                        {isRetailCircle && (
                          <p className="small-text mt-3">
                            Already have an account?{" "}
                            <Link to="/sign-in">Login here</Link>
                          </p>
                        )}
                    </Form>
                </>
                )}
            </Formik>
        </>
    )
};

export default Step1;
